module.exports = __webpack_public_path__ + "static/media/icon-piece5-8.db26bf06.png";